import React, { useContext, useEffect, useState } from 'react';
import {
    CancelSaveRightContentWrapper,
    ConfirmDeleteEvent,
    ErrorMessage,
    InfoMessage,
    EventGroupHeadingWrapper,
    EventGroupInputWrapper,
    EventGroupInputWrapperOuter,
    EventInputWrapper,
    EventTypeIconWrapper,
    HeadingWrapper,
    HeadingLeftWrapper,
    HeadingRightWrapper,
    ShoresideInstruction,
    ShoresideInstructionFile,
    ShoresideInstructionGroup,
    ShoresideInstructionOuter,
    ShoresideInstructionOuterGroup,
    ShoresideInstructionGroupFile,
    StyledButton,
    Wrapper,
    EventNameWrapper,
    PrinterButtonWrapper,
    EventContentWrapper,
} from './EventInput.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PrinterButton } from '../../styles/button.style';
import { useRotationStore } from '../../context/RotationContext';
import { useVesselStore } from '../../context/VesselContext';
import { SelectOption } from '../../types/ViewModel/SelectOption';
import { TankersEvent } from '../../types/ViewModel/TankersEvent';
import { useEventTypeStore } from '../../context/EventTypeContext';
import { useEventStore } from '../../context/EventContext';
import { EventType } from '../../types/ViewModel/EventType';
import EventDatetimeInput from './event-datetime-input/EventDatetimeInput';
import StringInput from './string-input/StringInput';
import { EventTypeInput } from '../../types/ViewModel/EventTypeInput';
import { InputDataTypeEnum } from '../../enums/inputDataTypeEnum';
import { EventTypeInputGroup } from '../../types/ViewModel/EventTypeInputGroup';
import EventTypeFactory from '../../factory/EventTypeFactory';
import EventTypeInputRegFactory from '../../factory/EventTypeInputRegFactory';
import DropdownInput from './dropdown-input/DropdownInput';
import IntegerInput from './integer-input/IntegerInput';
import DateInput from './date-input/DateInput';
import DecimalInput from './decimal-input/DecimalInput';
import RatingInput from './rating-input/RatingInput';
import { PortCall } from '../../types/ViewModel/PortCall';
import { BerthCall } from '../../types/ViewModel/BerthCall';
import { CargoOperation } from '../../types/ViewModel/CargoOperation';
import { CargoOperationTypeEnum } from '../../enums/cargoOperationTypeEnum';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import TankersEventFactory from '../../factory/TankersEventFactory';
import { EventDateFactory } from '../../factory/EventDateFactory';
import useRotation from '../../app/useRotation';
import usePostTankersEvent from '../../api/usePostTankersEvent';
import eventtypecommon from '../../utils/event/eventtypecommon';
import { EventTypeInputReg } from '../../types/ViewModel/EventTypeInputReg';
import useEvent from '../../app/useEvent';
import DropdownGroupRegFactory from '../../factory/DropdownGroupRegFactory';
import eventInputUtils from '../../utils/event/eventInputUtils';
import eventtypedeleteverify from '../../utils/event/eventtypedeleteverify';
import eventtypetimedateverify from '../../utils/event/eventtypetimedateverify';
import { ReportLocationEnum } from '../../enums/reportLocationEnum';
import { DropdownItem } from '../../types/ViewModel/DropdownItem';
import useDeleteTankersEvent from '../../api/useDeleteTankersEvent';
import { useAuthStore } from '../../context/AuthContext';
import { ErrorMsg } from '../../types/ViewModel/ErrorMsg';
import './EventInput.scss';
import ExcelReportInfoFactory from '../../factory/ExcelReportInfoFactory';
import { CargoReportEnum } from '../../enums/cargoReportEnum';
import usePostCreateExcel from '../../api/usePostCreateExcel';
import { ExcelReportInfoBM } from '../../types/BusinessModel/ExcelReportInfoBM';
import { DropdownItemReg } from '../../types/ViewModel/DropdownItemReg';
import { FrontendVersionEnum } from '../../enums/frontendVersionEnum';
import { CargoReportEventTypeEnum } from '../../enums/cargoReportEventTypeEnum';
import getShoresideInstructionContext from '../../context/ShoresideInstructionContext';
import RatingRegFactory from '../../factory/RatingRegFactory';
import { EventTypeData } from '../../types/ViewModel/EventTypeData';
import featureUtils from '../../utils/featureUtils';
import { Feature } from '../../enums/featureEnum';
import eventTypeGroupChangeLogUtils from '../../utils/event/eventTypeGroupChangeLogUtils';
import useApiLoaderHelper from '../../utils/useApiLoaderHelper';
import CheckBoxInput from './checkbox-input/CheckBoxInput';
import { useSWService } from '../../api/sw/useSWService';
import useApiEndpoints from '../../context/useApiEndpoints';
import { convertToLocalTime, createUtcTimeAdjustTimezones } from '../../utils/event/eventDateUtils';
import { getDateNow, getUtcTimeNow } from 'odfjell-date-time-utils/dateTimeUtils';
import { useConnectionStore } from 'src/context/ConnectionContext';
import { isNullOrUndefined } from 'src/utils/objectUtils';
import { AlertType } from 'src/types/alerts/AlertTypes';
import useAlertEngine from 'src/hooks/alerts/useAlertEngine';
import { EventTypeEnum } from 'src/enums/eventTypeEnum';
import { CargoEventReportData, REPORT_TYPE } from 'src/utils/reportGenerator/ReportGeneratorTypes';
import { useStowageStore } from 'src/context/StowageContext';
import { mapPortCallToRotationPortCallSimple } from 'src/utils/stowage/integrations/rotation/portCallUtils';
import { generateReport } from 'src/utils/reportGenerator/reportGenerator';
import { prettifyDateTime } from 'odfjell-date-time-utils/dateTimeFormatter';
import { AppFeatureEnum } from 'src/enums/appFeatureEnum';
import useAppFeature from 'src/app/useAppFeature';
import { useRetroactiveCargoMode } from 'src/context/RetroactiveCargoModeContext';

type Props = {
    tankersEvent: TankersEvent | null;
    eventType: EventType | null;
};

const EventInputComponent: React.FC<Props> = (props) => {
    const eventDateFactory = new EventDateFactory();
    const [isPrinterIconClicked, setIsPrinterIconClicked] = useState<boolean>(false);
    const [eventDatetimeLocal, setEventDatetimeLocal] = useState<Date | null>(null);
    const [isEventDatetimeValid, setIsEventDatetimeValid] = useState<boolean>(false);
    const [eventType, setEventType] = useState<EventType | null>(null);
    const [upsertedEvent, setUpsertedEvent] = useState<TankersEvent>();
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>('');
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [isDelayReasonFeatureEnabled, setIsDelayReasonFeatureEnabled] = useState<boolean>(false);
    const { role } = useAuthStore();
    const shoresideInstruction = useContext(getShoresideInstructionContext());

    const { storeEvent, updateEvent } = usePostTankersEvent();
    const { createExcel } = usePostCreateExcel();
    const { deleteEvent } = useDeleteTankersEvent();
    const { eventTypeDataPort, eventTypeDataSea, setSelectedEventType, eventTypeData } = useEventTypeStore();
    const { selectedNode, updatedRotation } = useRotationStore();
    const { fullEventArray, setSelectedEvent, setLastNotValidatingEvent } = useEventStore();
    const { selectedVessel } = useVesselStore();
    const {
        filterOnContextIncludeParent,
        filterOnContextIncludeParentWithBerthCall,
        isDelayExceeded,
        hasDelayInputItemReg,
        isDelayInput,
        filterOnContext,
    } = useEvent();
    const { getRequiredContextObj, getCargoOperationFromNode, getBerthCallFromNode, getPortCallFromNode } = useRotation();
    const { createNewEvent, createNewEventFromCode } = TankersEventFactory();
    const {
        isDateTimeInputValid,
        isStringInputValid,
        isIntegerInputValid,
        isDecimalInputValid,
        validateNumber,
        isDropdownInputValid,
        isRatingInputValid,
        isRatingCommentInputValid,
        isCheckboxInputValid,
    } = eventInputUtils();
    const { isFeatureEnabled: isFeatureEnabledLegacy } = featureUtils();
    const { isDeleteEventTypeValid } = eventtypedeleteverify();
    const { isDateTimeForNewEventValid, isDateTimeForUpdateEventValid } = eventtypetimedateverify();
    const { createExcelReportInfoBM } = ExcelReportInfoFactory();
    const { generateUuid, hasInputGroups, findEventTypeGroupSequenceDependentIdentity, getDependencyDisplayName } = eventtypecommon();
    const { newRatingRegFromCode } = RatingRegFactory();
    const { newDropdownGroupRegWithSelItems } = DropdownGroupRegFactory();
    const { createNewEventTypeInputRegFromCode, createNewEventTypeInputReg } = EventTypeInputRegFactory();
    const { createNewEventType } = EventTypeFactory();
    const { isMultiple, getRequiredPreviousTypeId } = eventTypeGroupChangeLogUtils();
    const { isLoadingType } = useApiLoaderHelper();
    const { refreshRequestsContaining } = useSWService();
    const { isOffline } = useConnectionStore();
    const { apiEndpoints } = useApiEndpoints();
    const { checkAlert } = useAlertEngine();
    const { loadedMasterStowagePlan } = useStowageStore();
    const { isFeatureEnabled } = useAppFeature();
    const { isRetroactiveCargoModeEnabled } = useRetroactiveCargoMode();

    // Clear error message when retroactive mode changes or event changes
    useEffect(() => {
        if (isRetroactiveCargoModeEnabled && props.tankersEvent) {
            // Check if this is a cargo-level event
            const isCargoEvent =
                props.tankersEvent.cargoOperationId !== null &&
                props.tankersEvent.cargoOperationId !== undefined &&
                props.tankersEvent.eventLevel === 2; // RotationTreeEnum.CargoOperation

            if (isCargoEvent) {
                // Clear validation errors when retroactive mode is enabled
                setErrorMsg('');
                setLastNotValidatingEvent(null);
            }
        } else if (!isRetroactiveCargoModeEnabled) {
            // Clear confirmation dialog when retroactive mode is disabled
            setShowConfirm(false);
        }
    }, [isRetroactiveCargoModeEnabled, props.tankersEvent]);

    useEffect(() => {
        let evType: EventType | null = null;
        let errMsg: ErrorMsg | null = null;
        let localTimePort: Date | null = null;
        const delayFeatEnabl = delayReasonEnable();

        // Clear error message and confirmation dialog when switching events or event types
        setErrorMsg('');
        setLastNotValidatingEvent(null);
        setShowConfirm(false);

        if (props.tankersEvent && props.tankersEvent.eventType) {
            evType = createNewEventType(props.tankersEvent.eventType);
            if (evType) {
                evType.parentSequenceNumber = props.tankersEvent.concurrentSequenceNumber;
            }
            initializeForUpdateEvent(props.tankersEvent, evType);
            setIsEventInputValid(props.tankersEvent, evType);
            localTimePort = createLocalTimePortUpdate(props.tankersEvent.eventDate.actualDateTimeLocal);
            errMsg = verifyDatetime(props.tankersEvent.eventDate.actualDateTimeLocal, props.tankersEvent.eventDate.actualDateTimeUtc);
        } else if (props.eventType) {
            evType = createNewEventType(props.eventType);
            const newEvent = generateNewEvent(props.eventType);
            localTimePort = createLocalTimePort();
            const utcTimePort = createUtcTimePort(newEvent, localTimePort);
            errMsg = verifyDatetime(localTimePort, utcTimePort);
        }
        setEventType(evType);
        setIsFormValid(checkIsFormValid(evType, null, !errMsg, localTimePort, delayFeatEnabl));
    }, [props.eventType, props.tankersEvent]);

    const delayReasonEnable = (): boolean => {
        const portCall = getPortCallFromNode(selectedNode);
        const portCallEvList = filterOnContext(portCall, fullEventArray);
        const featEnabl = isFeatureEnabledLegacy(Feature.DelayReason, portCallEvList);
        setIsDelayReasonFeatureEnabled(featEnabl);
        return featEnabl;
    };
    const isSavingTankersEvent = isLoadingType('isSavingTankersEvent');

    const getEvTypeData = (): EventTypeData => {
        return selectedNode?.reportLocation === ReportLocationEnum.Port ? eventTypeDataPort : eventTypeDataSea;
    };

    const createLocalTimePort = (): Date => {
        const localTime = new Date();
        const portCall = getPortCallFromNode(selectedNode);
        const localTimePort = convertToLocalTime(localTime, portCall?.port);
        setEventDatetimeLocal(localTimePort);
        return localTimePort;
    };

    const createUtcTimePort = (ev: TankersEvent, localTimePort: Date): Date => {
        const portCall = getPortCallFromNode(selectedNode);
        return createUtcTimeAdjustTimezones(portCall, ev, localTimePort, fullEventArray);
    };

    const createLocalTimePortUpdate = (localTime: Date): Date => {
        setEventDatetimeLocal(localTime);
        return localTime;
    };

    const checkIsFormValid = (
        evType: EventType | null,
        evTypeInp: EventTypeInput | null,
        eventDateValid: boolean,
        evDateTimeLocal: Date | null,
        delayFeatEnabl: boolean
    ): boolean => {
        if (evType && evType.eventTypeInputArray && evType.eventTypeInputArray.length > 0) {
            if (evTypeInp && !evTypeInp.isValid) {
                return false;
            }
            const contextIncludeParentSpecificEventArray = filterOnContextIncludeParentWithBerthCall(selectedNode, fullEventArray);
            const notValidInp = evType?.eventTypeInputArray?.find((eti) => {
                if (delayFeatEnabl) {
                    const hasInputDelayElem = Boolean(
                        evType.eventTypeInputDelayEventTypeMapArray.find((o) => o.eventTypeInputId === eti.eventTypeInputId)
                    );
                    if (hasInputDelayElem) {
                        if (!evTypeInp && evDateTimeLocal) {
                            const delayExceeded = isDelayExceeded(
                                updatedRotation,
                                evType,
                                contextIncludeParentSpecificEventArray,
                                eti,
                                evDateTimeLocal,
                                props.tankersEvent,
                                selectedNode
                            );
                            const hasDelayInpReg = hasDelayInputItemReg(eti, props.tankersEvent, evType);
                            return delayExceeded && !hasDelayInpReg;
                        }
                    }
                }
                if (!evTypeInp || eti.eventTypeInputId !== evTypeInp.eventTypeInputId) {
                    return !eti.isValid && eti.inputMandatory && eti.isEmpty && !eti.deleted;
                }
                return evTypeInp.inputMandatory && evTypeInp.isEmpty && !evTypeInp.deleted;
            });
            return !notValidInp && eventDateValid;
        }
        if (evType && (!evType.eventTypeInputArray || evType.eventTypeInputArray.length === 0)) {
            return true;
        }
        return false;
    };

    const setIsEventInputValid = (ev: TankersEvent, evType: EventType) => {
        if (evType.eventTypeInputArray && evType.eventTypeInputArray.length > 0) {
            evType.eventTypeInputArray?.forEach((evTypeInput) => {
                if (!evTypeInput.deleted) {
                    setGroupMandatoryInitial(ev, evType, evTypeInput);
                    switch (evTypeInput.inputDataTypeId) {
                        case InputDataTypeEnum.String:
                            evTypeInput.isValid = isStringInputValid(
                                evTypeInput,
                                evTypeInput.eventTypeInputReg ? evTypeInput.eventTypeInputReg.stringValueReg : null
                            );
                            evTypeInput.isEmpty = !(evTypeInput.eventTypeInputReg && evTypeInput.eventTypeInputReg.stringValueReg);
                            break;
                        case InputDataTypeEnum.Datetime:
                            evTypeInput.isValid = isDateTimeInputValid(
                                evTypeInput,
                                evTypeInput.eventTypeInputReg ? evTypeInput.eventTypeInputReg.datetimeValueReg : null
                            );
                            evTypeInput.isEmpty = !(evTypeInput.eventTypeInputReg && evTypeInput.eventTypeInputReg.datetimeValueReg);
                            break;
                        case InputDataTypeEnum.Int:
                            evTypeInput.isValid = isIntegerInputValid(
                                evTypeInput,
                                !isNullOrUndefined(evTypeInput.eventTypeInputReg?.intValueReg)
                                    ? evTypeInput.eventTypeInputReg.intValueReg.toString()
                                    : null
                            );
                            evTypeInput.isEmpty = isNullOrUndefined(evTypeInput.eventTypeInputReg?.intValueReg);
                            break;
                        case InputDataTypeEnum.Decimal:
                            evTypeInput.isValid = isDecimalInputValid(
                                evTypeInput,
                                !isNullOrUndefined(evTypeInput.eventTypeInputReg?.decimalValueReg)
                                    ? evTypeInput.eventTypeInputReg.decimalValueReg.toString()
                                    : null
                            );
                            evTypeInput.isEmpty = isNullOrUndefined(evTypeInput.eventTypeInputReg?.decimalValueReg);
                            break;
                        case InputDataTypeEnum.Rating: {
                            const noOfStars: number | null =
                                Boolean(evTypeInput.eventTypeInputReg) && Boolean(evTypeInput.eventTypeInputReg?.ratingReg)
                                    ? evTypeInput.eventTypeInputReg?.ratingReg?.ratingValue
                                    : null;
                            const ratingComment: string | null =
                                Boolean(evTypeInput.eventTypeInputReg) && Boolean(evTypeInput.eventTypeInputReg?.ratingReg)
                                    ? evTypeInput.eventTypeInputReg?.ratingReg?.ratingComment
                                    : null;
                            evTypeInput.isValid =
                                isRatingCommentInputValid(evTypeInput, noOfStars, ratingComment) && isRatingInputValid(evTypeInput, noOfStars);
                            evTypeInput.isEmpty = !(
                                evTypeInput.eventTypeInputReg &&
                                evTypeInput.eventTypeInputReg.ratingReg &&
                                evTypeInput.eventTypeInputReg.ratingReg.ratingValue
                            );
                            break;
                        }
                        case InputDataTypeEnum.Dropdown: {
                            const selOptions =
                                evTypeInput.eventTypeInputReg?.dropdownGroupReg?.dropdownItemRegList.map((ddItem) => {
                                    return new SelectOption(ddItem.dropdownItemRegId.toString(), ddItem.dropdownItemValue);
                                }) ?? null;
                            evTypeInput.isValid = isDropdownInputValid(evTypeInput, selOptions);
                            evTypeInput.isEmpty = !(evTypeInput.eventTypeInputReg && evTypeInput.eventTypeInputReg.stringValueReg);
                            break;
                        }
                        case InputDataTypeEnum.Checkbox:
                            evTypeInput.isValid = isCheckboxInputValid(
                                evTypeInput,
                                (evTypeInput.eventTypeInputReg && evTypeInput.eventTypeInputReg.checkboxValueReg) ?? null
                            );
                            evTypeInput.isEmpty = isNullOrUndefined(evTypeInput.eventTypeInputReg?.intValueReg);
                            break;
                    }
                }
            });
        }
    };

    const generateNewEvent = (evType: EventType): TankersEvent => {
        let portCall: PortCall | null = null;
        let berthCall: BerthCall | null = null;
        let cargoOperation: CargoOperation | null = null;
        let portId: number | null = null;
        let voyageNumber: string | null = null;
        let voyageNumber1: number | null = null;
        let voyageNumber2: number | null = null;
        let cargoNumber: string | null = null;
        let cargoId: number | null = null;
        let imosCargoId: number | null = null;
        let operationType: CargoOperationTypeEnum | null = null;
        let weight: number | null = null;
        let tradeName: string | null = null;

        switch (evType.levelId) {
            case RotationTreeEnum.CargoOperation:
                cargoOperation = getCargoOperationFromNode(selectedNode);
                if (cargoOperation) {
                    berthCall = cargoOperation.berthCall;
                    cargoNumber = cargoOperation.cargoNumber;
                    cargoId = cargoOperation.cargoId;
                    imosCargoId = cargoOperation.imosCargoId;
                    operationType = cargoOperation.cargoOperationType;
                    weight = cargoOperation.displayWeight;
                    tradeName = cargoOperation.tradeName;
                    if (berthCall) {
                        portCall = berthCall.portCall;
                        portId = berthCall.portCall?.port?.portId;
                        voyageNumber = berthCall.portCall?.voyageNumberPresentationString;
                        voyageNumber1 = +berthCall.portCall?.voyageNumber1;
                        voyageNumber2 = berthCall.portCall?.voyageNumber2 ? +berthCall.portCall?.voyageNumber2 : null;
                    }
                }
                break;
            case RotationTreeEnum.BerthCall:
                berthCall = getBerthCallFromNode(selectedNode);
                if (berthCall) {
                    portCall = berthCall.portCall;
                    portId = berthCall.portCall?.port.portId;
                    voyageNumber = berthCall.portCall?.voyageNumberPresentationString;
                    voyageNumber1 = +berthCall.portCall?.voyageNumber1;
                    voyageNumber2 = berthCall.portCall?.voyageNumber2 ? +berthCall.portCall?.voyageNumber2 : null;
                }
                break;
            case RotationTreeEnum.Sea:
            case RotationTreeEnum.PortCall:
                portCall = getPortCallFromNode(selectedNode);
                portId = portCall?.port?.portId ?? null;
                voyageNumber = portCall?.voyageNumberPresentationString;
                voyageNumber1 = +portCall?.voyageNumber1;
                voyageNumber2 = portCall?.voyageNumber2 ? +portCall?.voyageNumber2 : null;
                break;
            default:
        }

        const evTypeData = getEvTypeData();

        const newEvent = createNewEventFromCode(
            null,
            null,
            null,
            evType.eventTypeId,
            null,
            selectedVessel?.imoNumber,
            portCall ? portCall.portCallId : null,
            berthCall ? berthCall.berthCallId : null,
            berthCall ? berthCall.berthId : null,
            null,
            cargoOperation ? cargoOperation.cargoOperationId : null,
            null,
            null,
            null,
            eventDateFactory.createEmptyEventDate(),
            null,
            null,
            '', // updatedBy
            false,
            [],
            null,
            portId,
            voyageNumber,
            voyageNumber1,
            voyageNumber2,
            cargoNumber,
            cargoId,
            imosCargoId,
            operationType,
            weight,
            tradeName,
            evTypeData ? evTypeData.getVersion() : null,
            evType.eventTypeGroup?.eventTypeLevel?.eventTypeContextId,
            FrontendVersionEnum.OrcaWeb,
            evType,
            Boolean(portCall) && Boolean(portCall?.port) ? portCall?.port?.portName : null,
            getportClusterInitialPortId(portCall, berthCall),
            getportClusterInitialPortName(portCall, berthCall),
            berthCall ? berthCall?.name : null,
            false
        );
        setUpsertedEvent(newEvent);
        return newEvent;
    };

    const getportClusterInitialPortId = (portCall: PortCall | null, berthCall: BerthCall | null): number | null => {
        if (berthCall) {
            return berthCall.portClusterInitialPortId;
        }
        if (portCall) {
            return portCall.portClusterInitialPortId;
        }
        return null;
    };

    const getportClusterInitialPortName = (portCall: PortCall | null, berthCall: BerthCall | null): string | null => {
        if (berthCall) {
            return berthCall.portClusterInitialPortName;
        }
        if (portCall) {
            return portCall.portClusterInitialPortName;
        }
        return null;
    };

    const initializeForUpdateEvent = (event: TankersEvent, evType: EventType) => {
        if (event && event.eventDate) {
            setEventDatetimeLocal(event.eventDate.actualDateTimeLocal);
        }

        event.eventTypeInputRegList?.forEach((etir) => {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === etir.eventTypeInputId);
            if (evTypeInp) {
                evTypeInp.eventTypeInputReg = createNewEventTypeInputReg(etir);
            }
        });
    };

    const getDropdownItemReg = (event: TankersEvent, evTypeInpId: number): DropdownItemReg | null => {
        if (event.eventTypeInputRegList && event.eventTypeInputRegList.length > 0) {
            const evInpReg = event.eventTypeInputRegList.find((o) => o.eventTypeInputId == evTypeInpId);
            if (
                evInpReg &&
                evInpReg.dropdownGroupReg &&
                evInpReg.dropdownGroupReg.dropdownItemRegList &&
                evInpReg.dropdownGroupReg.dropdownItemRegList.length > 0
            ) {
                return evInpReg.dropdownGroupReg.dropdownItemRegList[0];
            }
        }
        return null;
    };

    const setGroupMandatoryInitial = (event: TankersEvent, evType: EventType, evTypeInp: EventTypeInput): EventTypeInput => {
        evType.eventTypeInputArray?.forEach((o) => {
            if (
                o.eventTypeInputId != evTypeInp.eventTypeInputId &&
                o.inputDataTypeId === InputDataTypeEnum.Dropdown &&
                o.dropdownGroup &&
                !o.dropdownGroup.multiple
            ) {
                const drDownItemReg = getDropdownItemReg(event, o.eventTypeInputId);
                if (drDownItemReg) {
                    const drItem = o.dropdownGroup.dropdownItemArray.find((drItem) => drItem.dropdownItemId === drDownItemReg.dropdownItemId);
                    if (drItem) {
                        const dropdownEventTypeItem = drItem?.dropdownItemEventTypeInputArray.find(
                            (dieti) => dieti.eventTypeInputId === evTypeInp.eventTypeInputId
                        );
                        if (dropdownEventTypeItem) {
                            evTypeInp.inputMandatory = dropdownEventTypeItem.mandatory;
                        } else {
                            evTypeInp.inputMandatory = evTypeInp.mandatory;
                        }
                    }
                }
            }
        });
        return evTypeInp;
    };

    const setGroupMandatory = (evTypeInp: EventTypeInput, dropdownItem: DropdownItem, selected: boolean): EventTypeInput => {
        if (!selected) {
            evTypeInp.inputMandatory = evTypeInp.mandatory;
        } else {
            const dropdownEventTypeItem = dropdownItem?.dropdownItemEventTypeInputArray.find(
                (dieti) => dieti.eventTypeInputId === evTypeInp.eventTypeInputId
            );
            if (dropdownEventTypeItem) {
                evTypeInp.inputMandatory = dropdownEventTypeItem.mandatory;
                evTypeInp.isValid = !evTypeInp.isEmpty;
            } else {
                evTypeInp.inputMandatory = evTypeInp.mandatory;
            }
        }
        return evTypeInp;
    };

    const setEventInputMandatoryFromSelected = (evType: EventType, selItems: SelectOption[], eventTypeInput: EventTypeInput): EventType => {
        if (!eventTypeInput?.dropdownGroup?.multiple) {
            const selected = selItems.length > 0;
            let dropdownItem: DropdownItem | null = null;
            if (selected) {
                dropdownItem = eventTypeInput?.dropdownGroup?.dropdownItemArray.find((eti) => eti.dropdownItemId === +selItems[0].value) ?? null;
            }
            if (dropdownItem && dropdownItem.dropdownItemEventTypeInputArray && dropdownItem.dropdownItemEventTypeInputArray.length > 0) {
                evType.eventTypeInputArray?.forEach((eti) => {
                    setGroupMandatory(eti, dropdownItem, selected);
                });
            }
        }
        return evType;
    };

    const verifyDatetime = (localDatetime: Date, utc: Date | null): ErrorMsg | null => {
        let utcDateTime: Date;
        if (utc) utcDateTime = utc;
        else utcDateTime = getUtcTimeNow();
        let verifyDate: ErrorMsg | null = null;
        if (props.tankersEvent) {
            // Temporarily update the local time for validation, then restore it
            const originalLocalTime = props.tankersEvent.eventDate.actualDateTimeLocal;
            props.tankersEvent.eventDate.actualDateTimeLocal = localDatetime;
            verifyDate = isDateTimeForUpdateEventValid(
                fullEventArray,
                getEvTypeData(),
                selectedNode,
                props.tankersEvent,
                utcDateTime,
                isRetroactiveCargoModeEnabled
            );
            props.tankersEvent.eventDate.actualDateTimeLocal = originalLocalTime;
        } else {
            verifyDate = isDateTimeForNewEventValid(
                fullEventArray,
                getEvTypeData(),
                selectedNode,
                props.eventType,
                utcDateTime,
                isRetroactiveCargoModeEnabled
            );
        }
        setEventDatetimeLocal(localDatetime);
        if (!verifyDate || !verifyDate.error) {
            // setLastNotValidatingEvent(null);
            // setEventDatetimeLocal(localDatetime);
            setIsEventDatetimeValid(true);
            setErrorMsg('');
            return null;
        } else {
            // setLastNotValidatingEvent(verifyDate.notValidatedEvent);
            setErrorMsg(verifyDate.message);
            setIsEventDatetimeValid(false);
            return verifyDate;
        }
    };

    const datetimeEventInputChangeHandler = (localDatetime: Date) => {
        const utc = createUtcTimePort(props.tankersEvent ?? upsertedEvent, localDatetime);
        const errMsg = verifyDatetime(localDatetime, utc);
        if (errMsg) {
            setLastNotValidatingEvent(errMsg.notValidatedEvent);
        } else {
            setLastNotValidatingEvent(null);
        }
        setIsFormValid(checkIsFormValid(eventType, null, !errMsg, localDatetime, isDelayReasonFeatureEnabled));
    };

    const stringInputChangeHandler = (strEvent: string | null, key: number, isEmpty: boolean, isValid: boolean) => {
        const evType = createNewEventType(eventType);
        if (evType) {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === key);
            if (evTypeInp) {
                if (!evTypeInp.eventTypeInputReg) {
                    evTypeInp.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.String,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        strEvent,
                        null,
                        null,
                        null,
                        isEmpty
                    );
                } else {
                    evTypeInp.eventTypeInputReg.stringValueReg = strEvent;
                }
                evTypeInp.isEmpty = isEmpty;
                evTypeInp.isValid = isValid;
                setEventType(evType);
                setIsFormValid(checkIsFormValid(evType, evTypeInp, isEventDatetimeValid, eventDatetimeLocal, isDelayReasonFeatureEnabled));
            }
        }
    };

    const dropdownInputChangeHandler = (selItems: SelectOption[], key: number, isEmpty: boolean, errorMsg: ErrorMsg) => {
        let evType = createNewEventType(eventType);
        if (evType) {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === key);
            if (evTypeInp) {
                if (!evTypeInp.eventTypeInputReg) {
                    const ddGroup = newDropdownGroupRegWithSelItems(
                        evTypeInp.dropdownGroup?.dropdownTypeId,
                        evTypeInp.dropdownGroup?.eventInputDropdownGroupId,
                        selItems
                    );
                    evTypeInp.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.String,
                        ddGroup,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        isEmpty
                    );
                } else {
                    evTypeInp.eventTypeInputReg.dropdownGroupReg = newDropdownGroupRegWithSelItems(
                        evTypeInp.dropdownGroup?.dropdownTypeId,
                        evTypeInp.dropdownGroup?.eventInputDropdownGroupId,
                        selItems
                    );
                }
                evType = setEventInputMandatoryFromSelected(evType, selItems, evTypeInp);
                evTypeInp.isEmpty = isEmpty;
                evTypeInp.isValid = !errorMsg.error;
                setEventType(evType);
                setErrorMsg(errorMsg.error ? errorMsg.message : '');
                setIsFormValid(checkIsFormValid(evType, evTypeInp, isEventDatetimeValid, eventDatetimeLocal, isDelayReasonFeatureEnabled));
            }
        }
    };

    const checkboxInputChangeHandler = (isChecked: boolean, key: number, isEmpty: boolean, isValid: boolean) => {
        const evType = createNewEventType(eventType);
        if (evType) {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === key);
            if (evTypeInp) {
                if (!evTypeInp.eventTypeInputReg) {
                    evTypeInp.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.Checkbox,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        isChecked,
                        isEmpty
                    );
                } else {
                    evTypeInp.eventTypeInputReg.checkboxValueReg = isChecked;
                }
                evTypeInp.isEmpty = isEmpty;
                evTypeInp.isValid = isValid;
                setEventType(evType);
                setIsFormValid(checkIsFormValid(evType, evTypeInp, isEventDatetimeValid, eventDatetimeLocal, isDelayReasonFeatureEnabled));
            }
        }
    };

    const integerInputChangeHandler = (intEventStr: string | null, key: number, isEmpty: boolean, isValid: boolean) => {
        const evType = createNewEventType(eventType);
        if (evType) {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === key);
            if (evTypeInp) {
                const intEvent = validateNumber(intEventStr);
                if (!evTypeInp.eventTypeInputReg) {
                    evTypeInp.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.String,
                        null,
                        null,
                        intEvent,
                        intEventStr,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        isEmpty
                    );
                } else {
                    evTypeInp.eventTypeInputReg.intValueReg = intEvent;
                    evTypeInp.eventTypeInputReg.intValueRegStr = intEventStr;
                }
                evTypeInp.isEmpty = isEmpty;
                evTypeInp.isValid = isValid;
                setEventType(evType);
                setIsFormValid(checkIsFormValid(evType, evTypeInp, isEventDatetimeValid, eventDatetimeLocal, isDelayReasonFeatureEnabled));
            }
        }
    };

    const decimalInputChangeHandler = (decEventStr: string | null, key: number, isEmpty: boolean, isValid: boolean) => {
        const evType = createNewEventType(eventType);
        if (evType) {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === key);
            if (evTypeInp) {
                const decEvent = validateNumber(decEventStr);
                if (!evTypeInp.eventTypeInputReg) {
                    evTypeInp.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.String,
                        null,
                        null,
                        null,
                        null,
                        decEvent,
                        decEventStr,
                        null,
                        null,
                        null,
                        null,
                        isEmpty
                    );
                } else {
                    evTypeInp.eventTypeInputReg.decimalValueReg = decEvent;
                    evTypeInp.eventTypeInputReg.decimalValueRegStr = decEventStr;
                }
                evTypeInp.isEmpty = isEmpty;
                evTypeInp.isValid = isValid;
                setEventType(evType);
                setIsFormValid(checkIsFormValid(evType, evTypeInp, isEventDatetimeValid, eventDatetimeLocal, isDelayReasonFeatureEnabled));
            }
        }
    };

    const dateInputChangeHandler = (dateTime: Date | null, key: number, isEmpty: boolean, isValid: boolean) => {
        const evType = createNewEventType(eventType);
        if (evType) {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === key);
            if (evTypeInp) {
                if (!evTypeInp.eventTypeInputReg) {
                    evTypeInp.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.String,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        dateTime,
                        null,
                        null,
                        isEmpty
                    );
                } else {
                    evTypeInp.eventTypeInputReg.datetimeValueReg = dateTime;
                }
                evTypeInp.isEmpty = isEmpty;
                evTypeInp.isValid = isValid;
                setEventType(evType);
                setIsFormValid(checkIsFormValid(evType, evTypeInp, isEventDatetimeValid, eventDatetimeLocal, isDelayReasonFeatureEnabled));
            }
        }
    };

    const ratingInputChangeHandler = (numberOfStars: number, comment: string | null, key: number, isEmpty: boolean, isValid: boolean) => {
        const evType = createNewEventType(eventType);
        if (evType) {
            const evTypeInp = evType.eventTypeInputArray?.find((inp) => inp.eventTypeInputId === key);
            if (evTypeInp) {
                if (!evTypeInp.eventTypeInputReg) {
                    // Create Rating object
                    const regRating = newRatingRegFromCode(generateUuid(), numberOfStars, comment);
                    evTypeInp.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.String,
                        null,
                        regRating,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        isEmpty
                    );
                } else {
                    evTypeInp.eventTypeInputReg.ratingReg.ratingValue = numberOfStars;
                    evTypeInp.eventTypeInputReg.ratingReg.ratingComment = comment;
                }
                evTypeInp.isEmpty = isEmpty;
                evTypeInp.isValid = isValid;
                setEventType(evType);
                setIsFormValid(checkIsFormValid(evType, evTypeInp, isEventDatetimeValid, eventDatetimeLocal, isDelayReasonFeatureEnabled));
            }
        }
    };

    const getSeqNr = (): number => {
        if (props.tankersEvent && props.tankersEvent.eventType && props.tankersEvent.concurrentSequenceNumber) {
            return props.tankersEvent.concurrentSequenceNumber;
        } else if (props.eventType && props.eventType.parentSequenceNumber) {
            return props.eventType.parentSequenceNumber;
        }
        return 1;
    };

    const getKey = (evTypeInp: EventTypeInput): string => {
        return 'inp-' + evTypeInp.eventTypeInputId.toString() + '-' + getSeqNr().toString();
    };

    const createInputItem = (evTypeInput: EventTypeInput) => {
        switch (evTypeInput.inputDataTypeId) {
            case InputDataTypeEnum.String:
                if (!evTypeInput.eventTypeInputReg) {
                    evTypeInput.eventTypeInputReg = createNewEventTypeInputRegFromCode(
                        0,
                        InputDataTypeEnum.String,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        false
                    );
                }
                return <StringInput onChange={stringInputChangeHandler} evTypeInput={evTypeInput} seqNr={getSeqNr()} key={getKey(evTypeInput)} />;
            case InputDataTypeEnum.Datetime:
                return <DateInput onChange={dateInputChangeHandler} evTypeInput={evTypeInput} key={getKey(evTypeInput)} />;
            case InputDataTypeEnum.Int:
                return <IntegerInput onChange={integerInputChangeHandler} evTypeInput={evTypeInput} key={getKey(evTypeInput)} />;
            case InputDataTypeEnum.Decimal:
                return <DecimalInput onChange={decimalInputChangeHandler} evTypeInput={evTypeInput} key={getKey(evTypeInput)} />;
            case InputDataTypeEnum.Rating:
                return <RatingInput onChange={ratingInputChangeHandler} evTypeInput={evTypeInput} key={getKey(evTypeInput)} />;
            case InputDataTypeEnum.Dropdown:
                return (
                    <DropdownInput
                        onChange={dropdownInputChangeHandler}
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        evType={eventType!}
                        evTypeInput={evTypeInput}
                        evTypeData={getEvTypeData()}
                        fullEventArray={fullEventArray}
                        key={getKey(evTypeInput)}
                    />
                );
            case InputDataTypeEnum.Checkbox:
                return <CheckBoxInput onChange={checkboxInputChangeHandler} evTypeInput={evTypeInput} key={getKey(evTypeInput)} />;
        }
    };

    const isUsedOrNotDeleted = (evTypeInput: EventTypeInput) => {
        return !!(!evTypeInput.deleted || evTypeInput.eventTypeInputReg);
    };

    const getInputItem = (evType: EventType, evTypeInput: EventTypeInput, evList: TankersEvent[]): EventTypeInput | null => {
        const hasInputDelayElem = Boolean(
            evType.eventTypeInputDelayEventTypeMapArray.find((o) => o.eventTypeInputId === evTypeInput.eventTypeInputId)
        );
        if (hasInputDelayElem && eventDatetimeLocal) {
            if (
                isDelayReasonFeatureEnabled &&
                isUsedOrNotDeleted(evTypeInput) &&
                isDelayExceeded(updatedRotation, evType, evList, evTypeInput, eventDatetimeLocal, props.tankersEvent, selectedNode)
            ) {
                evTypeInput.inputMandatory = isDelayInput(evType, evTypeInput);
                return evTypeInput;
            }
        } else {
            if (isUsedOrNotDeleted(evTypeInput)) {
                return evTypeInput;
            }
        }
        return null;
    };

    const createInputItemList = (evType: EventType, evTypeInputList: EventTypeInput[]) => {
        const inputItemList: any[] = [];
        const evTypeInputListSorted = evTypeInputList.sort((a, b) => (a.inputOrder > b.inputOrder ? 1 : -1));
        const contextIncludeParentSpecificEventArray = filterOnContextIncludeParentWithBerthCall(selectedNode, fullEventArray);
        evTypeInputListSorted.forEach((inpElem) => {
            const inpItem = getInputItem(evType, inpElem, contextIncludeParentSpecificEventArray);
            if (inpItem) {
                inputItemList.push(createInputItem(inpItem));
            }
        });
        return inputItemList;
    };

    const createGroupInputItemList = (evType: EventType, evTypeInputGroup: EventTypeInputGroup) => {
        const inputGroupItemList: any[] = [];
        const listSorted = evTypeInputGroup.eventTypeInputGroupItemArray.sort((a, b) => (a.itemOrder > b.itemOrder ? 1 : -1));
        const contextIncludeParentSpecificEventArray = filterOnContextIncludeParentWithBerthCall(selectedNode, fullEventArray);
        listSorted.forEach((grElem) => {
            const evTypeInput = evType.eventTypeInputArray?.find((evTypeInp) => evTypeInp.eventTypeInputId === grElem.eventTypeInputId) ?? null;
            if (evTypeInput) {
                const inpItem = getInputItem(evType, evTypeInput, contextIncludeParentSpecificEventArray);
                if (inpItem) {
                    inputGroupItemList.push(createInputItem(inpItem));
                }
            }
        });
        return inputGroupItemList;
    };

    const getGroupKey = (evTypeInputGroup: EventTypeInputGroup): string => {
        return 'group-' + evTypeInputGroup.eventTypeInputGroupId.toString();
    };

    const createGroupInputItem = (evType: EventType, evTypeInputGroup: EventTypeInputGroup) => {
        return (
            <EventGroupInputWrapperOuter key={getGroupKey(evTypeInputGroup)}>
                <EventGroupInputWrapper>
                    <EventGroupHeadingWrapper>
                        <h3>{evTypeInputGroup.heading}</h3>
                    </EventGroupHeadingWrapper>
                    {createGroupInputItemList(evType, evTypeInputGroup)}
                </EventGroupInputWrapper>
            </EventGroupInputWrapperOuter>
        );
    };

    const createGroupInputList = (evType: EventType) => {
        const groupInputItemList: any[] = [];
        const listSorted = evType.eventTypeInputGroupArray.sort((a, b) => (a.sectionOrder > b.sectionOrder ? 1 : -1));
        listSorted.forEach((groupElem) => {
            groupInputItemList.push(createGroupInputItem(evType, groupElem));
        });
        return groupInputItemList;
    };

    const generateInputItemList = (evType: EventType) => {
        if (hasInputGroups(evType)) {
            return createGroupInputList(evType);
        }
        return createInputItemList(evType, evType.eventTypeInputArray);
    };

    const getErrorMessage = () => {
        return <ErrorMessage>{errorMsg}</ErrorMessage>;
    };

    const getHeading = (evType: EventType | null) => {
        if (evType) return <h3>{evType.displayNameToolbox}</h3>;
        return null;
    };

    const getPrinterButton = () => {
        return (
            <PrinterButtonWrapper>
                <PrinterButton isSelected={isPrinterIconClicked} onClick={handlePrintEvent}>
                    <FontAwesomeIcon icon="print" title={getToolTip()} />
                </PrinterButton>
            </PrinterButtonWrapper>
        );
    };

    const getEventTypeIcon = (evType: EventType | null) => {
        if (evType) return <span dangerouslySetInnerHTML={{ __html: evType.icon }} />;
        return null;
    };

    const ifDelayInputItemThenInclude = (evTypeInp: EventTypeInput): boolean => {
        if (eventDatetimeLocal) {
            const hasInputDelayElem = Boolean(
                eventType?.eventTypeInputDelayEventTypeMapArray.find((o) => o.eventTypeInputId === evTypeInp.eventTypeInputId)
            );
            if (hasInputDelayElem) {
                if (!isDelayReasonFeatureEnabled) {
                    return false;
                }
                const contextIncludeParentSpecificEventArray = filterOnContextIncludeParentWithBerthCall(selectedNode, fullEventArray);
                return Boolean(
                    isDelayExceeded(
                        updatedRotation,
                        eventType,
                        contextIncludeParentSpecificEventArray,
                        evTypeInp,
                        eventDatetimeLocal,
                        props.tankersEvent,
                        selectedNode
                    )
                );
            }
        }
        return true;
    };

    const setInputRegValues = (): EventTypeInputReg[] => {
        const eventTypeInputArrayTemp: EventTypeInputReg[] = [];
        if (eventType && eventType.eventTypeInputArray) {
            eventType.eventTypeInputArray.forEach((evTypeInp) => {
                if (!evTypeInp.deleted && evTypeInp.eventTypeInputReg && ifDelayInputItemThenInclude(evTypeInp)) {
                    switch (evTypeInp.inputDataTypeId) {
                        case InputDataTypeEnum.Dropdown:
                            eventTypeInputArrayTemp.push(
                                createNewEventTypeInputRegFromCode(
                                    evTypeInp.eventTypeInputId,
                                    evTypeInp.inputDataTypeId,
                                    evTypeInp.eventTypeInputReg.dropdownGroupReg,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    true
                                )
                            );
                            break;
                        case InputDataTypeEnum.String:
                            if (evTypeInp.eventTypeInputReg) {
                                eventTypeInputArrayTemp.push(
                                    createNewEventTypeInputRegFromCode(
                                        evTypeInp.eventTypeInputId,
                                        evTypeInp.inputDataTypeId,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        evTypeInp.eventTypeInputReg.stringValueReg,
                                        null,
                                        null,
                                        null,
                                        true
                                    )
                                );
                            }
                            break;
                        case InputDataTypeEnum.Int:
                            eventTypeInputArrayTemp.push(
                                createNewEventTypeInputRegFromCode(
                                    evTypeInp.eventTypeInputId,
                                    evTypeInp.inputDataTypeId,
                                    null,
                                    null,
                                    evTypeInp.eventTypeInputReg.intValueReg,
                                    evTypeInp.eventTypeInputReg.intValueRegStr,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    true
                                )
                            );
                            break;
                        case InputDataTypeEnum.Decimal:
                            eventTypeInputArrayTemp.push(
                                createNewEventTypeInputRegFromCode(
                                    evTypeInp.eventTypeInputId,
                                    evTypeInp.inputDataTypeId,
                                    null,
                                    null,
                                    null,
                                    null,
                                    evTypeInp.eventTypeInputReg.decimalValueReg,
                                    evTypeInp.eventTypeInputReg.decimalValueRegStr,
                                    null,
                                    null,
                                    null,
                                    null,
                                    true
                                )
                            );
                            break;
                        case InputDataTypeEnum.Rating: {
                            const regRating = newRatingRegFromCode(
                                evTypeInp.eventTypeInputReg.ratingReg?.ratingRegId,
                                evTypeInp.eventTypeInputReg.ratingReg?.ratingValue,
                                evTypeInp.eventTypeInputReg.ratingReg?.ratingComment
                            );
                            eventTypeInputArrayTemp.push(
                                createNewEventTypeInputRegFromCode(
                                    evTypeInp.eventTypeInputId,
                                    evTypeInp.inputDataTypeId,
                                    null,
                                    regRating,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    true
                                )
                            );
                            break;
                        }
                        case InputDataTypeEnum.Datetime:
                            eventTypeInputArrayTemp.push(
                                createNewEventTypeInputRegFromCode(
                                    evTypeInp.eventTypeInputId,
                                    evTypeInp.inputDataTypeId,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    evTypeInp.eventTypeInputReg.datetimeValueReg,
                                    null,
                                    null,
                                    true
                                )
                            );
                            break;
                        case InputDataTypeEnum.Checkbox:
                            eventTypeInputArrayTemp.push(
                                createNewEventTypeInputRegFromCode(
                                    evTypeInp.eventTypeInputId,
                                    evTypeInp.inputDataTypeId,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    null,
                                    evTypeInp.eventTypeInputReg.checkboxValueReg,
                                    true
                                )
                            );
                            break;
                    }
                }
            });
        }
        return eventTypeInputArrayTemp;
    };

    const getEventWithMaxConcurrentSequenceNumber = (evList: TankersEvent[]): TankersEvent => {
        const maxEv = Math.max(
            ...evList.map(function (o) {
                return o.concurrentSequenceNumber;
            })
        );
        return evList.find((ev) => (ev.concurrentSequenceNumber = maxEv));
    };

    const findConcurrentSequenceNumber = (inputEvent: TankersEvent): number => {
        let concurrentSeqNumber = 1;

        const contextIncludeParentSpecificEventArray = filterOnContextIncludeParent(selectedNode, fullEventArray);

        // Find all events for actual group for actual context and parents
        const eventListForGroup: TankersEvent[] = contextIncludeParentSpecificEventArray.filter(
            (ev) => ev.eventType?.eventTypeGroupId === inputEvent.eventType?.eventTypeGroupId
        );

        if (eventListForGroup && eventListForGroup.length > 0) {
            const eventForSeq = eventListForGroup.find((event) => event.eventTypeGroupSequenceIdentity === inputEvent.eventTypeGroupSequenceIdentity);

            if (eventForSeq && eventForSeq.concurrentSequenceNumber) {
                concurrentSeqNumber = eventForSeq.concurrentSequenceNumber;
            } else {
                // Check if current event type group is multiple
                if (isMultiple(inputEvent.eventType?.eventTypeGroup, selectedNode?.firstTimeInPortCall)) {
                    // Find parent sequence
                    const eventListForParent: TankersEvent[] = contextIncludeParentSpecificEventArray.filter(
                        (ev) =>
                            ev.eventType?.eventTypeId ===
                            getRequiredPreviousTypeId(inputEvent.eventType?.eventTypeGroup, selectedNode?.firstTimeInPortCall)
                    );
                    if (eventListForParent && eventListForParent.length > 0) {
                        const evListParentSeq = eventListForParent.find(
                            (ev) => ev.concurrentSequenceNumber === inputEvent.eventType?.parentSequenceNumber
                        );
                        if (evListParentSeq) {
                            const evListSeqDep = eventListForGroup.filter(
                                (ev) => ev.eventTypeGroupSequenceDependencyIdentity === evListParentSeq.eventTypeGroupSequenceIdentity
                            );
                            if (!evListSeqDep || evListSeqDep.length === 0) {
                                concurrentSeqNumber = 1;
                            } else {
                                const maxEv = getEventWithMaxConcurrentSequenceNumber(evListSeqDep);
                                if (maxEv && maxEv.concurrentSequenceNumber) {
                                    concurrentSeqNumber = maxEv.concurrentSequenceNumber + 1;
                                }
                            }
                        } else {
                            const maxEv = getEventWithMaxConcurrentSequenceNumber(eventListForGroup);
                            if (maxEv && maxEv.concurrentSequenceNumber) {
                                concurrentSeqNumber = maxEv.concurrentSequenceNumber + 1;
                            }
                        }
                    } else {
                        const maxEv = getEventWithMaxConcurrentSequenceNumber(eventListForGroup);
                        if (maxEv && maxEv.concurrentSequenceNumber) {
                            concurrentSeqNumber = maxEv.concurrentSequenceNumber + 1;
                        }
                    }
                }
            }
        } else {
            concurrentSeqNumber = 1;
        }
        return concurrentSeqNumber;
    };

    const newEventToSave = (): TankersEvent => {
        const newEvent = createNewEvent(upsertedEvent);
        newEvent.eventId = generateUuid();
        newEvent.eventTypeInputRegList = setInputRegValues();
        newEvent.eventDate = eventDateFactory.createNewEventDate(null, null, createUtcTimePort(newEvent, eventDatetimeLocal), eventDatetimeLocal);
        const now = getUtcTimeNow();
        newEvent.created = now;
        newEvent.lastUpdated = now;
        newEvent.deleted = false;

        const obj = getRequiredContextObj(selectedNode, eventType?.levelId);
        newEvent.eventTypeGroupSequenceIdentity = props.eventType?.eventTypeGroupSequenceIdentity
            ? props.eventType.eventTypeGroupSequenceIdentity
            : generateUuid();
        if (newEvent.eventType?.parentSequenceNumber) {
            newEvent.concurrentSequenceNumber = newEvent.eventType?.parentSequenceNumber;
        } else {
            newEvent.concurrentSequenceNumber = findConcurrentSequenceNumber(newEvent);
        }
        newEvent.eventTypeGroupSequenceDependencyIdentity = findEventTypeGroupSequenceDependentIdentity(
            fullEventArray,
            getEvTypeData(),
            obj,
            newEvent
        );

        newEvent.dependencyDisplayName = getDependencyDisplayName(fullEventArray, newEvent, getEvTypeData(), true, selectedNode);
        return newEvent;
    };

    const updateEventToSave = (): TankersEvent => {
        const updatedEvent = createNewEvent(props.tankersEvent);
        updatedEvent.eventTypeInputRegList = setInputRegValues();
        updatedEvent.eventDate = eventDateFactory.createNewEventDate(
            null,
            null,
            createUtcTimePort(updatedEvent, eventDatetimeLocal),
            eventDatetimeLocal
        );
        updatedEvent.lastUpdated = getUtcTimeNow();
        updatedEvent.deleted = false;

        updatedEvent.dependencyDisplayName = getDependencyDisplayName(fullEventArray, updatedEvent, getEvTypeData(), false, selectedNode);

        // Update cargo dropdown items if changed from (U) => (L) or vice versa
        // updateCargoDropdownItems(updatedEvent);

        return updatedEvent;
    };

    const saveBtn = () => {
        let eventResponse = null;
        let event: TankersEvent | null = null;
        if (props.tankersEvent) {
            event = updateEventToSave();
            eventResponse = updateEvent(event);
        } else {
            event = newEventToSave();
            eventResponse = storeEvent(event);
        }
        eventResponse.then((response) => {
            if (response) {
                const params = '?voyageNumber1=' + props.tankersEvent?.voyageNumber1 + '&voyageNumber2=&imoNumber=' + selectedVessel.imoNumber;
                refreshRequestsContaining([apiEndpoints['getTankersEventDataDeltaForVoyage'].url], params);

                if (event.eventTypeId === EventTypeEnum.SOSP) {
                    checkAlert({
                        alertType: AlertType.MISSING_INHIBITOR_QUESTIONNAIRE,
                        contextData: {
                            portCallId: event.portCallId,
                            alertSourceDate: event.eventDate.actualDateTimeLocal ? new Date(event.eventDate.actualDateTimeLocal) : undefined,
                        },
                    });
                }
            }
        });
    };

    const confirmDeleteEvent = () => {
        const canDeleteEvent = isDeleteEventTypeValid(
            fullEventArray,
            selectedNode,
            props.tankersEvent,
            getEvTypeData(),
            isRetroactiveCargoModeEnabled
        );
        if (!canDeleteEvent.error) {
            setLastNotValidatingEvent(null);
            setShowConfirm(true);
        } else {
            setLastNotValidatingEvent(canDeleteEvent.notValidatedEvent);
            setErrorMsg(canDeleteEvent.message);
        }
    };

    const deleteSelectedEvent = () => {
        const deleteResponse = deleteEvent(props.tankersEvent?.shipId, props.tankersEvent?.eventId);
        deleteResponse.then((response) => {
            if (response) {
                setShowConfirm(false);
                setErrorMsg('Deleted');
                const params = '?voyageNumber1=' + props.tankersEvent.voyageNumber1 + '&voyageNumber2=&imoNumber=' + selectedVessel.imoNumber;
                refreshRequestsContaining([apiEndpoints['getTankersEventDataDeltaForVoyage'].url], params);
                setTimeout(() => {
                    setSelectedEvent(null);
                }, 500);
            }
        });
    };

    const cancelBtn = () => {
        setLastNotValidatingEvent(null);
        setSelectedEventType(null);
        setSelectedEvent(null);
    };

    const cancelDeleteEvent = () => {
        setLastNotValidatingEvent(null);
        setShowConfirm(false);
    };

    const createShoresideInstructionForGroup = (evType: EventType) => {
        return (
            <ShoresideInstructionOuterGroup>
                <ShoresideInstructionGroup>{evType.shoresideInstruction}</ShoresideInstructionGroup>
            </ShoresideInstructionOuterGroup>
        );
    };

    const createShoresideInstructionForGroupFromFile = (evType: EventType) => {
        return (
            <ShoresideInstructionOuterGroup>
                <ShoresideInstructionGroupFile eventTypeId={evType?.eventTypeId}>
                    <div dangerouslySetInnerHTML={{ __html: getShoresideInstructionHtml() }} />
                </ShoresideInstructionGroupFile>
            </ShoresideInstructionOuterGroup>
        );
    };

    const createShoresideInstruction = (evType: EventType) => {
        return (
            <ShoresideInstructionOuter>
                <ShoresideInstruction>{evType.shoresideInstruction}</ShoresideInstruction>
            </ShoresideInstructionOuter>
        );
    };

    const getShoresideInstructionHtml = () => {
        return shoresideInstruction;
    };

    const createShoresideInstructionFromFile = (evType: EventType) => {
        return (
            <ShoresideInstructionOuter>
                <ShoresideInstructionFile eventTypeId={evType?.eventTypeId}>
                    <div dangerouslySetInnerHTML={{ __html: getShoresideInstructionHtml() }} />
                </ShoresideInstructionFile>
            </ShoresideInstructionOuter>
        );
    };

    const getShoresideInstruction = (evType: EventType) => {
        if (evType.shoresideInstruction) {
            if (hasInputGroups(evType)) {
                if (evType.shoresideInstruction === 'file') return createShoresideInstructionForGroupFromFile(evType);
                return createShoresideInstructionForGroup(evType);
            } else {
                if (evType.shoresideInstruction === 'file') return createShoresideInstructionFromFile(evType);
                return createShoresideInstruction(evType);
            }
        }
        return null;
    };

    const hasReaderPermissionOnly = () => {
        return role && !role.isWriter;
    };
    const showPrinterIcon = (): boolean => {
        return !!(props.tankersEvent && props.tankersEvent.eventType?.captainsDocument) && !isOffline;
    };

    const getExcelReportInfo = (type: CargoReportEnum, filename: string): ExcelReportInfoBM | null => {
        const pc = getPortCallFromNode(selectedNode);
        if (pc && pc.port) {
            const bc = getBerthCallFromNode(selectedNode);
            const pc = getPortCallFromNode(selectedNode);
            if (pc) {
                return createExcelReportInfoBM(
                    type,
                    selectedVessel?.imoNumber,
                    getPortCallFromNode(selectedNode)?.portCallId,
                    pc.isInPortCluster,
                    [],
                    [],
                    null,
                    null,
                    props.tankersEvent?.eventId,
                    filename,
                    pc.port ? pc.port.portId : 0,
                    bc ? bc.berthId : null,
                    null
                );
            }
        }
        return null;
    };

    const getExcelEventType = (): ExcelReportInfoBM | null => {
        switch (props.tankersEvent?.eventTypeId) {
            case CargoReportEventTypeEnum.NORTender:
                return getExcelReportInfo(CargoReportEnum.NORTender, 'NOR Tender');
            case CargoReportEventTypeEnum.CertificateOfCleanliness:
                return getExcelReportInfo(CargoReportEnum.CertificateOfCleanliness, 'Certificate of Cleanliness');
            case CargoReportEventTypeEnum.EmptyTankCertificate:
                return getExcelReportInfo(CargoReportEnum.EmptyTankCertificate, 'Empty Tank Certificate');
            case CargoReportEventTypeEnum.DeadfreightClaim:
                return getExcelReportInfo(CargoReportEnum.DeadfreightClaim, 'Protest Deadfreight Claim');
            case CargoReportEventTypeEnum.ProtestDiff:
                return getExcelReportInfo(CargoReportEnum.ProtestDiff, 'Protest Different Figures');
            case CargoReportEventTypeEnum.SlowRate:
                return getExcelReportInfo(CargoReportEnum.SlowRate, 'Protest Low Rate');
            case CargoReportEventTypeEnum.InsufficientNumberOfHoses:
                return getExcelReportInfo(CargoReportEnum.InsufficientNumberOfHoses, 'Protest Insufficient Hoses');
            case CargoReportEventTypeEnum.GeneralProtest:
                return getExcelReportInfo(CargoReportEnum.GeneralProtest, 'General Protest');
            case CargoReportEventTypeEnum.ReTenderNOR:
                return getExcelReportInfo(CargoReportEnum.ReTenderNOR, 'NOR Tender');
            case CargoReportEventTypeEnum.UseOfVesselHoses:
                return getExcelReportInfo(CargoReportEnum.UseOfVesselHoses, 'Use of Vessel Hoses Protest');
            case CargoReportEventTypeEnum.FreePratique:
                return getExcelReportInfo(CargoReportEnum.FreePratique, 'Protest Free Pratique');
        }
        return null;
    };

    const getToolTip = (): string => {
        switch (props.tankersEvent?.eventTypeId) {
            case CargoReportEventTypeEnum.NORTender:
                return 'Click to generate NOR Tender document';
            case CargoReportEventTypeEnum.CertificateOfCleanliness:
                return 'Click to generate certificate of cleanliness';
            case CargoReportEventTypeEnum.EmptyTankCertificate:
                return 'Click to generate empty tank certificate';
            case CargoReportEventTypeEnum.DeadfreightClaim:
                return 'Click to generate protest deadfreight claim';
            case CargoReportEventTypeEnum.ProtestDiff:
                return 'Click to generate protest different figures ship/shore';
            case CargoReportEventTypeEnum.SlowRate:
                return 'Click to generate protest low load/unload rate';
            case CargoReportEventTypeEnum.InsufficientNumberOfHoses:
                return 'Click to generate protest insufficient number of hoses';
            case CargoReportEventTypeEnum.GeneralProtest:
                return 'Click to generate general protest';
            case CargoReportEventTypeEnum.UseOfVesselHoses:
                return 'Click to generate protest use of vessel hoses';
            case CargoReportEventTypeEnum.FreePratique:
                return 'Click to generate protest for free pratique';
        }
        return '';
    };

    const mapEventTypeIdToReportType = () => {
        switch (props.tankersEvent?.eventTypeId) {
            case CargoReportEventTypeEnum.NORTender:
                return REPORT_TYPE.NOR_TENDER;
            case CargoReportEventTypeEnum.ReTenderNOR:
                return REPORT_TYPE.RE_TENDER_NOR;
            case CargoReportEventTypeEnum.CertificateOfCleanliness:
                return REPORT_TYPE.CERTIFICATE_OF_CLEANLINESS;
            case CargoReportEventTypeEnum.EmptyTankCertificate:
                return REPORT_TYPE.EMPTY_TANK_CERTIFICATE;
            case CargoReportEventTypeEnum.DeadfreightClaim:
                return REPORT_TYPE.PROTEST_DEADFREIGHT_CLAIM;
            case CargoReportEventTypeEnum.ProtestDiff:
                return REPORT_TYPE.PROTEST_DIFF;
            case CargoReportEventTypeEnum.SlowRate:
                return REPORT_TYPE.SLOW_RATE;
            case CargoReportEventTypeEnum.InsufficientNumberOfHoses:
                return REPORT_TYPE.INSUFFICIEN_NUMBER_HOSES_REPORT;
            case CargoReportEventTypeEnum.GeneralProtest:
                return REPORT_TYPE.GENERAL_PROTEST;
            case CargoReportEventTypeEnum.UseOfVesselHoses:
                return REPORT_TYPE.PROTEST_USE_OF_VESSEL_HOSES;
            case CargoReportEventTypeEnum.FreePratique:
                return REPORT_TYPE.PROTEST_FREE_PRATIQUE;
        }
    };

    const handlePrintEvent = async () => {
        const excelReportInfo = getExcelEventType();

        if (
            isFeatureEnabled({ featureEnum: AppFeatureEnum.StowageIntegration, imoNumber: selectedVessel.imoNumber, date: getDateNow() }) &&
            loadedMasterStowagePlan
        ) {
            const pc = getPortCallFromNode(selectedNode);
            const reportType = mapEventTypeIdToReportType();
            if (!pc || !excelReportInfo) return;
            const reportData: CargoEventReportData = {
                stowagePlan: loadedMasterStowagePlan,
                vessel: selectedVessel,
                tankersEvents: fullEventArray,
                eventTypeData: eventTypeData,
                portCallId: pc.portCallId,
                reportType,
                selectedPortCall: mapPortCallToRotationPortCallSimple(pc, selectedVessel.imoNumber),
                excelReportInfo: excelReportInfo,
            };
            const result = await generateReport([{ data: reportData, reportType }]);

            const fileName = `${excelReportInfo.filename} ${prettifyDateTime(new Date())}.xlsx`;
            if (result.success) {
                try {
                    const _downloadLink = document.createElement('a');
                    _downloadLink.href = result.dataUri;
                    _downloadLink.download = fileName;
                    _downloadLink.style.display = 'none';
                    document.body.appendChild(_downloadLink);
                    _downloadLink.click();
                } catch (error) {
                    console.error('Error generating report:', error);
                }
            }
        } else {
            createExcel(excelReportInfo);
        }
        setIsPrinterIconClicked(!isPrinterIconClicked);
    };

    return (
        <>
            {eventType && selectedNode && (
                <Wrapper style={hasReaderPermissionOnly() ? { pointerEvents: 'none' } : {}}>
                    <HeadingWrapper>
                        <HeadingLeftWrapper>
                            <EventTypeIconWrapper>{getEventTypeIcon(eventType)}</EventTypeIconWrapper>
                            <EventNameWrapper>{getHeading(eventType)}</EventNameWrapper>
                        </HeadingLeftWrapper>
                        <HeadingRightWrapper>{showPrinterIcon() && getPrinterButton()}</HeadingRightWrapper>
                    </HeadingWrapper>

                    <EventContentWrapper>
                        <EventInputWrapper>
                            <EventDatetimeInput onChange={datetimeEventInputChangeHandler} initialValue={eventDatetimeLocal} />
                            {generateInputItemList(eventType)}
                            {getErrorMessage()}
                            {getShoresideInstruction(eventType)}
                            {isSavingTankersEvent && <InfoMessage>Saving...</InfoMessage>}
                        </EventInputWrapper>
                        {!hasReaderPermissionOnly() && (
                            <CancelSaveRightContentWrapper>
                                {props.tankersEvent && (
                                    <>
                                        {!showConfirm && (
                                            <ConfirmDeleteEvent>
                                                <StyledButton className="delete-btn" disabled={false} isSelected={true} onClick={confirmDeleteEvent}>
                                                    Delete
                                                </StyledButton>
                                            </ConfirmDeleteEvent>
                                        )}
                                        {showConfirm && (
                                            <ConfirmDeleteEvent>
                                                <h4>Delete this event?</h4>
                                                <StyledButton disabled={false} isSelected={true} onClick={cancelDeleteEvent}>
                                                    Cancel
                                                </StyledButton>
                                                <StyledButton disabled={false} isSelected={true} onClick={deleteSelectedEvent}>
                                                    Delete
                                                </StyledButton>
                                            </ConfirmDeleteEvent>
                                        )}
                                    </>
                                )}
                                {!showConfirm && (
                                    <ConfirmDeleteEvent>
                                        <StyledButton className="cancel-btn" disabled={false} isSelected={true} onClick={cancelBtn}>
                                            Cancel
                                        </StyledButton>
                                        <StyledButton
                                            className="primary-btn"
                                            disabled={!isFormValid || hasReaderPermissionOnly() || !!isSavingTankersEvent}
                                            isSelected={isFormValid}
                                            onClick={saveBtn}
                                        >
                                            Save
                                        </StyledButton>
                                    </ConfirmDeleteEvent>
                                )}
                            </CancelSaveRightContentWrapper>
                        )}
                    </EventContentWrapper>
                </Wrapper>
            )}
        </>
    );
};

export default EventInputComponent;
